import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { deleteMastergroupingsFromAPI, fetchMastergroupingsFromAPI } from "../../../services/MastergroupingService";


export const fetchMastergroupings = createAsyncThunk(
  "mastergroupings/fetchMastergroupings",
  async ({ page, perPage, search }, { rejectWithValue }) => {
    try {
      const response = await fetchMastergroupingsFromAPI(page, perPage, search);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal mengambil data pengguna");
    }
  }
);


export const deleteMastergrouping = createAsyncThunk(
  "mastergroupings/deleteMastergrouping",
  async (mastergroupingId, { rejectWithValue }) => {
    try {
      const response = await deleteMastergroupingsFromAPI(mastergroupingId);
      return response;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Gagal menghapus data pengguna");
    }
  }
);



const mastergroupingSlice = createSlice({
  name: "mastergroupings",
  initialState: {
    mastergroupings: [],
    currentPage: 1,
    lastPage: 1,
    perPage: 10,
    firstItem: 1,
    mastergroupingSearch: "",
    loading: false,
    error: null,
    totalCount:0,
    keywordSearch:""
  },
  reducers: {
    setSearchMastergrouping: (state, action) => {
      state.mastergroupingSearch = action.payload;
    },
    setPage: (state, action) => {
      state.currentPage = action.payload;
    },
    setVisibilityFilter: (state, action) => {
      state.currentFilter = action.payload;
    },
    setPerPage: (state, action) => {
      state.perPage = action.payload;
    },
    setKeywordSearch: (state, action) => {
      state.keywordSearch = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchMastergroupings.pending, (state) => {
        state.loading = true;
      })
      .addCase(fetchMastergroupings.fulfilled, (state, action) => {
        state.loading = false;
        state.mastergroupings = action.payload.data;
        state.currentPage = action.payload.meta.current_page;
        state.lastPage = action.payload.meta.last_page;
        state.perPage = action.payload.meta.per_page;
        state.firstItem = action.payload.meta.from; // ✅ Ambil `from` dari API
        state.totalCount = action.payload.meta.total;
      })
      .addCase(fetchMastergroupings.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(deleteMastergrouping.fulfilled, (state, action) => {
        state.mastergroupings = state.mastergroupings.filter(mastergrouping => mastergrouping.id !== action.payload);
      })
      .addCase(deleteMastergrouping.rejected, (state, action) => {
        state.error = action.payload;
      });
  },
});

export const { setSearchMastergrouping, setPage, setVisibilityFilter, setPerPage, setKeywordSearch } = mastergroupingSlice.actions;
export default mastergroupingSlice.reducer;
